export const ANIMATION_TYPES = {
  EASE: "ease",
  EASE_IN: "ease-in",
  EASE_OUT: "ease-out",
  EASE_IN_OUT: "ease-in-out",
  LINEAR: "linear",
  CUBIC_BEZIER: "cubic-bezier",
};

export const CUBIC_BEZIER_FN = "cubic-bezier(0.1, 0.7, 1, 0.1)";
